module.exports = __webpack_public_path__ + "img/home__5fhn——vi.05fee594.png";